module.exports = __webpack_public_path__ + "img/meme_31.9ffe9de4.jpg";